import { createSlice } from '@repo/store';

export type HeaderNavState = {
  /**
   * Whether the current route/page wants the desktop header nav links + auth button.
   * When false, Header should render only the brand + search mount (no right-side nav).
   */
  enabled: boolean;
};

export type HeaderNavSlice = HeaderNavState & {
  setEnabled: (enabled: boolean) => void;
};

const initialState: HeaderNavState = {
  enabled: true,
};

export const headerNavSlice = createSlice({
  name: 'headerNav',
  initialState,
  actions: ({ setSlice }) => ({
    setEnabled: (enabled: boolean) =>
      setSlice(prev => ({
        ...prev,
        enabled,
      })),
  }),
});
